import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import { connect } from 'react-redux'
import paginationFactory, {
  PaginationProvider,
  SizePerPageDropdownStandalone,
  PaginationListStandalone,
} from 'react-bootstrap-table2-paginator'
import filterFactory from 'react-bootstrap-table2-filter'
import { Button } from 'reactstrap'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { handleDetailsClick, handleDeleteCompany } from '../actions/companyActions'
import Moment from 'react-moment'
import DropDownTableItem from './DropDownTableItem'
import SyncResult from '../Shared/SyncResult'

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css'

import '../CompanyDetails/CompanyUsers/navoverrides.css'

const { SearchBar } = Search

const CompaniesTable = ({ companies, handleDetailsClick }) => {
  const companyFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Button color="link" style={{ textAlign: 'left' }}>
        {cell}
      </Button>
    )
  }

  const syncResultFormatter = (cell, row, rowIndex, formatExtraData) => {
    return <SyncResult result={cell} />
  }

  const syncDateFormatter = (cell, row, rowIndex, formatExtraData) => {
    const isValid = new Date(cell) > new Date('01/01/2000 00:00')
    if (isValid) {
      return <Moment format="DD/MM/YYYY">{cell}</Moment>
    } else {
      return <span>No Synchronizations</span>
    }
  }

  const dropdownFormatter = (cell, row, rowIndex, formatExtraData) => {
    return <DropDownTableItem cell={cell} row={row} rowIndex={rowIndex} formatExtraData={formatExtraData} />
  }

  const columns = [
    {
      dataField: 'id',
      text: 'Id',
      hidden: true,
      editable: false,
    },
    {
      dataField: 'companyName',
      text: 'Company Name',
      sort: true,
      editable: false,
      headerStyle: (column, colIndex) => {
        return { width: '300px' }
      },
      formatter: companyFormatter,
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          handleDetailsClick(row.id)
        },
      },
    },
    {
      dataField: 'userCount',
      text: 'User Count',
      sort: true,
      editable: false,
    },
    {
      dataField: 'billedUserCount',
      text: 'Billed User Count',
      sort: true,
      editable: false,
    },
    {
      dataField: 'lastSyncDate',
      text: 'Last Sync Date',
      sort: true,
      editable: false,
      formatter: syncDateFormatter,
    },
    {
      dataField: 'lastSyncResult',
      text: 'Last Sync Result',
      sort: true,
      editable: false,
      formatter: syncResultFormatter,
    },
    {
      dataField: 'companyActions',
      text: 'Actions',
      sort: false,
      editable: false,
      formatter: dropdownFormatter,
    },
  ]

  if (companies && companies.length > 0) {
    return (
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          totalSize: companies.length,
          sizePerPageList: [
            { text: '10', value: 10 },
            { text: '20', value: 20 },
            { text: '50', value: 50 },
            { text: '100', value: 100 },
            { text: 'All', value: companies.length },
          ],
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider bootstrap4 keyField="id" data={companies} columns={columns} search>
            {(props) => {
              return (
                <div>
                  <SearchBar {...props.searchProps} />
                  <PaginationListStandalone {...paginationProps} />
                  <SizePerPageDropdownStandalone
                    btnContextual="btn-outline-primary"
                    className="dropDownStyle"
                    {...paginationProps}
                  />
                  <BootstrapTable
                    bordered={false}
                    {...props.baseProps}
                    pagination={paginationFactory()}
                    filter={filterFactory()}
                    filterPosition="top"
                    {...paginationTableProps}
                  />
                </div>
              )
            }}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    )
  } else {
    return <div>No Companies Found</div>
  }
}

const mapDispatchToProps = {
  handleDetailsClick,
  handleDeleteCompany,
}

export default connect(null, mapDispatchToProps)(CompaniesTable)
